module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bIp0Z"))).then(() => parcelRequire('1iHdE'));